/** A roughly 1 km grid permits cache reuse without removing local search bias. */
export function roundGeocoderLocationBias(lat: number, lon: number) {
  return { lat: Number(lat.toFixed(2)), lon: Number(lon.toFixed(2)) };
}
